import Vacancies from "./Vacancies";
import Maintenance from "./maintenance/Maintenance";
import Motivos from "./maintenance/Motivo";
import Pais from "./maintenance/Pais";
import Estados from "./maintenance/Estados";
import DashboardSeleccionContratacion from "./DashboardSeleccionContratacion";
import RequirementsMonitor from "./RequirementsMonitor";
import RequestTracking from "./RequestTracking";
import DashboardPowerBI from "./powerBI/dashboardPowerBI";
import PositionHistory from "./PositionHistory";

const SeleccionContratacionRouter = [
  {
    type: "private",
    path: "/seleccion-contratacion/:type",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Seleccion_Contratacion",
      "alta_direccion",
    ],
    component: Vacancies,
    exact: true,
  },
  {
    type: "private",
    path: "/seleccion-contratacion/mantenimiento/motivo",
    roles: ["administrador", "Responsable_Seleccion_Contratacion"],
    component: Motivos,
    exact: true,
  },
  {
    type: "private",
    path: "/seleccion-contratacion/mantenimiento/pais",
    roles: ["administrador", "Responsable_Seleccion_Contratacion"],
    component: Pais,
    exact: true,
  },
  {
    type: "private",
    path: "/seleccion-contratacion/mantenimiento/estado",
    roles: ["administrador", "Responsable_Seleccion_Contratacion"],
    component: Estados,
    exact: true,
  },
  {
    type: "private",
    // path: "/seleccion-contratacion/dashboardSeleccionContratacion",
    path: "/seleccion-contratacion/indicadores/indicador-selección-y-contratacion",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Seleccion_Contratacion",
      "alta_direccion",
    ],
    component: DashboardSeleccionContratacion,
    exact: true,
  },
  {
    type: "private",
    path: "/seleccion-contratacion/mantenimientos/admin",
    roles: ["administrador", "Responsable_Seleccion_Contratacion"],
    component: Maintenance,
    exact: true,
  },
  {
    type: "private",
    path: "/seleccion-contratacion/monitor-de-requerimientos/:type/:id/:nombrePuesto/:codigo/:rol",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Seleccion_Contratacion",
      "alta_direccion",
    ],
    component: RequirementsMonitor,
    exact: true,
  },
  {
    type: "private",
    path: "/seleccion-contratacion/seguimiento-solitudes/:type/:id/:nombrePuesto/:codigoPuesto/:idSolicitud/:rol",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Seleccion_Contratacion",
      "alta_direccion",
    ],
    component: RequestTracking,
    exact: true,
  },
  {
    type: "private",
    // path: "/Dashboard-Seleccion-Contratacion-PowerBI",
    path: "/tablero-selección-y-contratación",
    roles: [
      "administrador",
      "alta_direccion",
      "Responsable_Seleccion_Contratacion",
    ],
    component: DashboardPowerBI,
    exact: true,
  },
  {
    type: "private",
    path: "/seleccion-contratacion/positionHistory/:type/:id/:nombrePuesto/:codigo/:rol",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Seleccion_Contratacion",
      "alta_direccion",
    ],
    component: PositionHistory,
    exact: true,
  },
];

export default SeleccionContratacionRouter;
